module.exports = __webpack_public_path__ + "assets/img/my-item-02.47c97be1.png";